import { useEffect, useRef, useState } from 'react';

const StyleForm = (vm) => {
  const contentRef = useRef(null);
  const [shouldCenterCreate, setShouldCenterCreate] = useState(false);

  const isCenterView =
    vm.authView === 'forgotPassword' || vm.authView === 'resetPassword';

  const isLoginView = vm.authView === 'login';
  const isCreateAccount = vm.authView === 'createAccount';

  useEffect(() => {
    if (!isCreateAccount) {
      setShouldCenterCreate(false);
      return;
    }
    const checkHeight = () => {
      const contentHeight = contentRef.current?.offsetHeight || 0;
      const viewportHeight = window.innerHeight;
      setShouldCenterCreate(contentHeight < viewportHeight - 40);
    };
    checkHeight();
    window.addEventListener('resize', checkHeight);
    return () => window.removeEventListener('resize', checkHeight);
  }, [isCreateAccount, vm.authView]);

  return {
    contentRef,
    isLoginView,
    isCenterView,
    isCreateAccount,
    shouldCenterCreate
  }
};

export default StyleForm;
